import type {
  TripWrite,
} from 'src/common/external/bambi-api/bambiApi';
import type {
  TripsBulkCreateWrite,
} from 'src/common/external/bambi-api/tripsApi';

import type { AddTripFormValues } from '../FormValues';
import { buildNewTripPayload } from './adaptFormValuesHelpers';

export function adaptFormValuesToTripsBulkCreate(
  formValues: AddTripFormValues
): TripsBulkCreateWrite {
  return {
    trips: formValues.trips.map(
      (trip): TripWrite => buildNewTripPayload(trip, formValues)
    ),
  };
}
